export default __webpack_public_path__ + "static/HalvarBreit-XBd-07b6cdba380f528013391f47aef4a62d.woff";